import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui'
import Vue from 'vue'
import locale from 'element-ui/lib/locale/lang/ru-RU'

Vue.use(Element, { locale })
